// InsuranceFacilityList?projectId=1

import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchInsuranceFacility: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveInsuranceFacility: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchInsuranceFacilityData = createApiThunk("insuranceFacility", "fetch")
export const saveInsuranceFacilityData = createApiThunk("insuranceFacility", "save")

// Slice
const insuranceFacilitySlice = createSlice({
    name: "insuranceFacility",
    initialState,

    reducers: {
        resetInsuranceState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchInsuranceFacility = {
                    ...state.fetchInsuranceFacility, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveInsuranceFacility = {
                    ...state.saveInsuranceFacility, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchInsuranceFacilityData.pending, (state) => updateState(state, "pending", "fetchInsuranceFacility"))
            .addCase(fetchInsuranceFacilityData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchInsuranceFacility", action.payload.data))
            .addCase(fetchInsuranceFacilityData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchInsuranceFacility", action.payload))
            // Save data
            .addCase(saveInsuranceFacilityData.pending, (state) => updateState(state, "pending", "saveInsuranceFacility"))
            .addCase(saveInsuranceFacilityData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveInsuranceFacility", action.payload.data))
            .addCase(saveInsuranceFacilityData.rejected, (state, action) =>
                updateState(state, "rejected", "saveInsuranceFacility", action.payload));
    },
});

export const { resetInsuranceState } = insuranceFacilitySlice.actions;
export default insuranceFacilitySlice.reducer;
